import { createAppSelector } from "./base";

import type { UserType } from "components/server-types";
import { RootState } from "store";

export const selectAssessmentInfoForPage = createAppSelector(
  [(state) => state.computed, (state, pageId: string) => pageId],
  (computed, pageId) => computed.pageAssessmentStatuses[pageId],
);

export const selectAllAssessmentInfo = (state: RootState) => state.computed.pageAssessmentStatuses;

export const selectInviteStatusForUser = createAppSelector(
  [(state) => state.computed, (state, user: UserType) => user],
  (computed, user) => computed.userInviteStatuses[user.id],
);

export const selectUserInviteStatuses = (state: RootState) => state.computed.userInviteStatuses;
